/**
 * @author Madhu.Sudhan
 * @Date: 2023-04-18 13:05:06
 * @Last Modified by: madhusudhan
 * @Last Modified time: 2023-04-05 17:50:20
 */

import React, { Fragment, PureComponent } from 'react';
import OtpInput from 'react-otp-input';
import { connect } from 'react-redux';
import { Card, Row, Col, Form, Breadcrumb, Slider, Divider, Button, Modal, Icon, Input, Switch } from 'antd';

import { AppWrappperHOC } from '../Root/HOC';
import { CALCULATE_BALANCE, DEFAULT_PRE_TRANS_PAYLOAD } from '../NetworkCards/constants';
import { constants, utils } from '../../devUtils';
import Container from '../../components/Container';
import { StyledTransactionLimits } from './StyledYesBankTransactionLimits';
import { ZaggleCard, FlipCards, NsdlFlipCards } from '../NetworkCards/StyledNetworkCard';
import { StyledOtpGeneration } from '../PayBalance/StyledPayBalance';
import { YBL_MODIFY_LIMITS_CONSTANTS } from './constants';
import { YesBankTransactionLimitsProps, yesBankTransactionLimitsMapStateToProps, yesBankTransactionLimitsMapDispatchToProps } from './yesBankTransactionLimitsDataHandler';

class YesBankTransactionLimits extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      atm_set_amount: 0,
      pos_set_amount: 0,
      ecom_set_amount: 0,
      atm_max_per_day: 0,
      pos_max_per_day: 0,
      ecom_max_per_day: 0,
      atm_consumed_count: 0,
      pos_consumed_count: 0,
      ecom_consumed_count: 0,
      modalType: '',
      OTP: '',
      showResendText: false,
      remainingTime: 60,
      atmEnabled: false,
      posEnabled: false,
      ecomEnabled: false,
    };
    this.statelesskeys = {
      defaultPayload: {},
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleResendOTP = this.handleResendOTP.bind(this);
    this.handleOTPChange = this.handleOTPChange.bind(this);
    this.handleModal = this.handleModal.bind(this);
    this.yblModifyLimitOtp = this.yblModifyLimitOtp.bind(this);
    this.setNewLimit = this.setNewLimit.bind(this);
    this.setNewVolume = this.setNewVolume.bind(this);
    this.setConsumedCount = this.setConsumedCount.bind(this);
    this.setInputValue = this.setInputValue.bind(this);
    this.setInputValueCount = this.setInputValueCount.bind(this);
    this.handleSwitch = this.handleSwitch.bind(this);
  }

  /**
   * @function React lifecycle
   */
  componentDidMount() {
    const {
      onFetchCardData,
      onFetchOnlineTransactionLimit,
    } = this.props;
    const payload = { ...DEFAULT_PRE_TRANS_PAYLOAD };
    this.statelesskeys.defaultPayload = payload;
    onFetchCardData();
    onFetchOnlineTransactionLimit();
  }

  componentWillReceiveProps(nextProps) {
    const {
      transactionLimits,
      transactionLimits: {
        status,
        limits = [],
      } = {},
      updateTransactionLimits,
      updateTransactionLimits: {
        status: update_status,
      } = {},
      isYblModifyLimitsOtpSuccess,
      isYblModifyLimitsOtpSuccess: {
        status: otp_success,
      } = {},
      onFetchOnlineTransactionLimit,
      onSetUpdateYesBankTransactionLimitSuccess,
      onSetYesBankTransactionLimitOtpSuccess,
      isyblSetChannelFlagSuccess,
      isyblSetChannelFlagSuccess: {
        status: setChannelFlagSuccess,
      } = {},
      onFetchCardData,
      cardData,
      cardData: {
        status: cardDataStatus = false,
        isAtmEnabled = false,
        isPosEnabled = false,
        isEcomEnabled = false,
      } = {},
    } = nextProps;
    const {
      transactionLimits: _transactionLimits,
      updateTransactionLimits: _updateTransactionLimits,
      isYblModifyLimitsOtpSuccess: _isYblModifyLimitsOtpSuccess,
      isyblSetChannelFlagSuccess: _isyblSetChannelFlagSuccess,
      cardData: _cardData,
    } = this.props;
    if (!utils.isEqual(transactionLimits, _transactionLimits) && status) {
      this.setTransactionLimits(limits);
    } else if (!utils.isEqual(updateTransactionLimits, _updateTransactionLimits) && update_status) {
      this.setState({ modalType: 'YBL_LIMIT_SETTING' });
      this.startTimer();
    } else if (!utils.isEqual(isYblModifyLimitsOtpSuccess, _isYblModifyLimitsOtpSuccess) && otp_success) {
      onSetUpdateYesBankTransactionLimitSuccess();
      this.handleModal();
      onFetchOnlineTransactionLimit();
      onSetYesBankTransactionLimitOtpSuccess();
      this.setState({ OTP: '' });
    } else if (!utils.isEqual(isyblSetChannelFlagSuccess, _isyblSetChannelFlagSuccess) && setChannelFlagSuccess) {
      onFetchCardData();
    }
    if (!utils.isEqual(cardData, _cardData) && cardDataStatus) {
      this.setState({
        atmEnabled: isAtmEnabled,
        posEnabled: isPosEnabled,
        ecomEnabled: isEcomEnabled,
      });
    }
  }

  setTransactionLimits(limits) {
    const {
      SelectUserDetails: {
        ybl_wearable = false,
      } = {},
    } = this.props;
    if (ybl_wearable) {
      const {
        amount: pos_amount = '',
        daily_transaction_volume: daily_pos_transaction_volume = '',
        transaction_limit_consumed: pos_transaction_limit_consumed = '',
      } = limits[0] || {};
      const {
        amount: ecom_amount = '',
        daily_transaction_volume: daily_ecom_transaction_volume = '',
        transaction_limit_consumed: ecom_transaction_limit_consumed = '',
      } = limits[1] || {};
      this.setState({
        pos_set_amount: Number(pos_amount),
        ecom_set_amount: Number(ecom_amount),
        pos_max_per_day: Number(daily_pos_transaction_volume),
        ecom_max_per_day: Number(daily_ecom_transaction_volume),
        pos_consumed_count: Number(pos_transaction_limit_consumed),
        ecom_consumed_count: Number(ecom_transaction_limit_consumed),
      });
    } else {
      const {
        amount: atm_amount = '',
        daily_transaction_volume: daily_atm_transaction_volume = '',
        transaction_limit_consumed: atm_transaction_limit_consumed = '',
      } = limits[0] || {};
      const {
        amount: pos_amount = '',
        daily_transaction_volume: daily_pos_transaction_volume = '',
        transaction_limit_consumed: pos_transaction_limit_consumed = '',
      } = limits[1] || {};
      const {
        amount: ecom_amount = '',
        daily_transaction_volume: daily_ecom_transaction_volume = '',
        transaction_limit_consumed: ecom_transaction_limit_consumed = '',
      } = limits[2] || {};
      this.setState({
        atm_set_amount: Number(atm_amount),
        pos_set_amount: Number(pos_amount),
        ecom_set_amount: Number(ecom_amount),
        atm_max_per_day: Number(daily_atm_transaction_volume),
        pos_max_per_day: Number(daily_pos_transaction_volume),
        ecom_max_per_day: Number(daily_ecom_transaction_volume),
        atm_consumed_count: Number(atm_transaction_limit_consumed),
        pos_consumed_count: Number(pos_transaction_limit_consumed),
        ecom_consumed_count: Number(ecom_transaction_limit_consumed),
      });
    }
  }

  setNewLimit(type) {
    const {
      atm_set_amount,
      pos_set_amount,
      ecom_set_amount,
    } = this.state;
    switch (type) {
      case 'ATM':
        return atm_set_amount;
      case 'POS':
        return pos_set_amount;
      case 'ECOM':
        return ecom_set_amount;
      default:
        return 0;
    }
  }

  setInputValue(type, value) {
    this.setState({ [`${type.toLowerCase()}_set_amount`]: value });
  }

  setConsumedCount(type) {
    const {
      atm_consumed_count,
      pos_consumed_count,
      ecom_consumed_count,
    } = this.state;
    switch (type) {
      case 'ATM':
        return atm_consumed_count;
      case 'POS':
        return pos_consumed_count;
      case 'ECOM':
        return ecom_consumed_count;
      default:
        return 0;
    }
  }

  setNewVolume(type) {
    const {
      atm_max_per_day,
      pos_max_per_day,
      ecom_max_per_day,
    } = this.state;
    switch (type) {
      case 'ATM':
        return atm_max_per_day;
      case 'POS':
        return pos_max_per_day;
      case 'ECOM':
        return ecom_max_per_day;
      default:
        return 0;
    }
  }

  setInputValueCount(type, value) {
    this.setState({ [`${type.toLowerCase()}_max_per_day`]: value });
  }

  isChecked(type) {
    const {
      atmEnabled,
      posEnabled,
      ecomEnabled,
    } = this.state;
    switch (type) {
      case 'ATM':
        return atmEnabled;
      case 'POS':
        return posEnabled;
      case 'ECOM':
        return ecomEnabled;
      default:
        return false;
    }
  }

  handleSwitch(type, value) {
    const {
      onSetChannelFlagYbl,
      cardData: {
        card_type = '',
        kit_number = '',
      } = {},
    } = this.props;

    onSetChannelFlagYbl({ channel_name: type, channel_flag: value ? 'Enable' : 'Disable', kit_number, card_type });
  }

  handleModal(type) {
    this.setState({
      modalType: typeof (type) === 'string' ? type : '',
    });
  }

  handleSubmit() {
    const {
      onUpdateOnlineTransactionLimit,
      SelectUserDetails: {
        ybl_wearable = false,
      } = {},
    } = this.props;
    const {
      atm_set_amount,
      pos_set_amount,
      ecom_set_amount,
      atm_max_per_day,
      pos_max_per_day,
      ecom_max_per_day,
    } = this.state;
    if (ybl_wearable) {
      const payload = {
        pos_amount: pos_set_amount.toString(),
        ecom_amount: ecom_set_amount.toString(),
        daily_pos_transaction_volume: pos_max_per_day.toString(),
        daily_ecom_transaction_volume: ecom_max_per_day.toString(),
      };
      onUpdateOnlineTransactionLimit(payload);
    } else {
      const payload = {
        atm_amount: atm_set_amount.toString(),
        pos_amount: pos_set_amount.toString(),
        ecom_amount: ecom_set_amount.toString(),
        daily_atm_transaction_volume: atm_max_per_day.toString(),
        daily_pos_transaction_volume: pos_max_per_day.toString(),
        daily_ecom_transaction_volume: ecom_max_per_day.toString(),
      };
      onUpdateOnlineTransactionLimit(payload);
    }
  }

  handleChangeTransactionValues(type, value) {
    switch (type) {
      case 'ATM':
        return this.setState({ atm_set_amount: parseFloat(value) });
      case 'POS':
        return this.setState({ pos_set_amount: parseFloat(value) });
      case 'ECOM':
        return this.setState({ ecom_set_amount: parseFloat(value) });
      default:
        return '';
    }
  }

  handleChangeTransactionVolume(type, value) {
    switch (type) {
      case 'ATM':
        return this.setState({ atm_max_per_day: parseFloat(value) });
      case 'POS':
        return this.setState({ pos_max_per_day: parseFloat(value) });
      case 'ECOM':
        return this.setState({ ecom_max_per_day: parseFloat(value) });
      default:
        return '';
    }
  }

  handleResendOTP() {
    this.setState({ modalType: 'YBL_LIMIT_SETTING' });
    clearInterval(this.timer);
    this.setState({
      showResendText: false,
      remainingTime: 60,
    });
    this.startTimer();
  }

  handleOTPChange(OTP) {
    this.setState({ OTP });
  }

  startTimer() {
    this.timer = setInterval(() => {
      const { remainingTime } = this.state;
      if (remainingTime === 1) {
        clearInterval(this.timer);
        this.setState({ showResendText: true });
      }
      this.setState((prevState) => ({
        remainingTime: prevState.remainingTime - 1,
      }));
    }, 1000);
  }

  yblModifyLimitOtp() {
    const {
      onResetPopup,
      updateTransactionLimits: {
        otp_ref_number = '',
      } = {},
      onYblModifyLimitsOtp,
    } = this.props;
    const { OTP } = this.state;
    if (!OTP.length) {
      onResetPopup(constants.ALERT_FIELD_REQUIRED, 'error');
    } else if (OTP.length !== 6) {
      onResetPopup(constants.ALERT_OTP_MINIMUM_DIGITS, 'error');
    } else {
      const payload = {
        otp_ref_number,
        otp: OTP,
      };
      onYblModifyLimitsOtp(payload);
    }
  }

  renderModalUI(modalType) {
    const {
      SelectUserDetails: {
        phone = '',
      } = {},
      yblModifyLimitOtpLoading,
    } = this.props;
    const {
      OTP,
      showResendText,
      remainingTime,
    } = this.state;
    const formattedPhone = `XXXXXX${phone.slice(-4)}`;
    switch (modalType) {
      case 'YBL_LIMIT_SETTING':
        return (
          <StyledOtpGeneration>
            <Card className="rounded otp-card margin-b-1">
              <Row align="top" type="flex" justify="start" gutter={10}>
                <Col xs={24} sm={24} md={2} lg={2} xl={2}>
                  <Icon type="check-circle" theme="filled" className="check-icon" />
                </Col>
                <Col xs={24} sm={24} md={22} lg={22} xl={22}>
                  <p className="font-14">OTP has been Successfully sent to <strong> {formattedPhone} </strong>. {YBL_MODIFY_LIMITS_CONSTANTS.COMPLETE_OTP_VERIFICATION}
                  </p>
                  <p className="font-12 text-red"> {YBL_MODIFY_LIMITS_CONSTANTS.CONTACT_CUSTOMER_CARE}
                  </p>
                </Col>
              </Row>
            </Card>
            <Row align="middle" type="flex" justify="center" gutter={10}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} className="margin-t-1 margin-b-1">
                <OtpInput
                  containerStyle={{ justifyContent: 'center' }}
                  className="custom-otp-inputs"
                  value={OTP}
                  onChange={this.handleOTPChange}
                  numInputs={6}
                  separator={<span className="padding-1"></span>}
                  isInputNum
                />
              </Col>
              <div>
                {showResendText ? (
                  <span
                    role="presentation"
                    className="text-red"
                    style={{ cursor: 'pointer' }}
                    onClick={this.handleResendOTP}
                  >
                    Resend OTP
                  </span>
                ) : (
                  <span>Resend OTP in 0 : {remainingTime} sec</span>
                )}
              </div>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center">
                <Button
                  loading={yblModifyLimitOtpLoading}
                  type="primary"
                  className="green-btn width-5 margin-t-1"
                  onClick={this.yblModifyLimitOtp}
                >
                  Confirm
                </Button>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <p className="font-14 nomargin-bottom margin-t-2">
                  Customer Service Number<br />
                  <strong>1860 500 1231</strong><br />
                  Timings - Monday to Saturday ( 10 AM - 7 PM)
                </p>
              </Col>
            </Row>
          </StyledOtpGeneration>
        );
      default:
        return <div />;
    }
  }

  renderModalCloseFunction(modalType) {
    switch (modalType) {
      case 'YBL_LIMIT_SETTING':
        return this.handleModal;
      default:
        return () => '';
    }
  }

  renderCardImages(cardData) {
    let showImage = null;
    const {
      location: {
        pathname = '',
      } = {},
    } = this.props;
    const { cvv, card_type, card_name, ProxyNumber, expiry_month, expiry_year, CardStatus } = cardData;
    if (cvv) {
      showImage = (
        <Fragment>
          <input type="checkbox" id="CardClick" />
          <label className="card-containert" htmlFor="CardClick">
            <div className="card-flip">
              <div className={`side ${!['physical', 'virtual'].includes(card_type) ? 'default-user' : ''}`}>
                <h1><strong>Rs. {CALCULATE_BALANCE(cardData, card_type)}</strong></h1>
                <h2>{card_name}</h2>
                <div className="footer">
                  <b>
                    <span>Card Number:</span> {ProxyNumber}<br />
                    <span>Expiry:</span> {expiry_month}/{expiry_year}<br />
                    <span>Card Status:</span> {CardStatus}<br />
                  </b>
                </div>
              </div>
              <div className="side back">
                <h3>{cvv}</h3>
              </div>
            </div>
          </label>
        </Fragment>
      );
    } else {
      showImage = (
        <div className="card-flip default">
          <div className={`side ${!['Physical', 'Virtual'].includes(card_type) ? 'default-user' : ''}`}>
            <h1><strong>Rs. {CALCULATE_BALANCE(cardData, card_type)}</strong></h1>
            <h2>{card_name}</h2>
            <div className="footer">
              <Row align="middle" type="flex" gutter={24}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <b>
                    <span>Card Number:</span> {ProxyNumber}<br />
                    {expiry_month ? <Fragment><span>Expiry:</span> {expiry_month}/{expiry_year}<br /></Fragment> : null}
                    <span>Card Status:</span> {CardStatus}<br />
                  </b>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      );
    }
    return (
      <Col xs={24} sm={24} md={10} lg={10} xl={10}>
        { pathname === constants.YES_BANK_LIMITS ?
          <FlipCards>
            {showImage}
          </FlipCards> :
          <NsdlFlipCards>
            {showImage}
          </NsdlFlipCards>
        }
      </Col>
    );
  }

  renderYesBankTransactionLimits() {
    const {
      transactionLimits: {
        limits = [],
      } = {},
      isYblTransactionLimitsLoading,
      history = {},
    } = this.props;
    return (
      <Col xs={24} sm={24} md={14} lg={14} xl={14}>
        <StyledTransactionLimits>
          {limits.map(({ name = '', amount = '', max_amount = '', daily_transaction_volume = '', max_daily_transaction_volume = '' }, index) => (
            <Fragment>
              <h3> {name} Transactions</h3>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} className="padding-tb-2">
                <Row align="top" type="flex" gutter={[8, 8]}>
                  <Col xs={8} sm={8} md={8} lg={8} xl={8}>
                    <div className="font-12">Current Limit</div>
                    <div className="font-12">{amount || 0}</div>
                  </Col>
                  <Col xs={8} sm={8} md={8} lg={8} xl={8}>
                    <div className="font-12">New Limit</div>
                    <Input
                      className="width-4"
                      type="text"
                      placeholder="Enter"
                      value={this.setNewLimit(name)}
                      onChange={({ target: { value = '' } }) => this.setInputValue(name, value)}
                    >
                    </Input>
                  </Col>
                  <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                    <Switch
                      className="custom-switch"
                      loading={isYblTransactionLimitsLoading}
                      checked={this.isChecked(name)}
                      onChange={(value) => this.handleSwitch(name, value)}
                    />
                  </Col>

                  <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                    <span className="font-12">ATM Transaction Limit</span>
                    <Slider
                      min={0}
                      max={Number(max_amount) || 0}
                      step={100}
                      className="custom-slider"
                      value={this.setNewLimit(name)}
                      onChange={(value) => this.handleChangeTransactionValues(name, value)}
                    />
                  </Col>
                  <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                    <div className="show-slider-values margin-b-1">
                      <span>0</span>
                      <span>{max_amount}</span>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} className="padding-tb-2">
                <Row align="top" type="flex" gutter={[8, 8]}>
                  <Col xs={8} sm={8} md={8} lg={8} xl={8}>
                    <div className="font-12">Current Count</div>
                    <div className="font-12">{Number(daily_transaction_volume) || 0}</div>
                  </Col>
                  <Col xs={8} sm={8} md={8} lg={8} xl={8}>
                    <div className="font-12">New Count</div>
                    <Input
                      className="width-3"
                      type="text"
                      placeholder="Enter"
                      value={this.setNewVolume(name)}
                      onChange={({ target: { value } }) => this.setInputValueCount(name, value)}
                    >
                    </Input>
                  </Col>
                  <Col xs={8} sm={8} md={8} lg={8} xl={8}>
                    <div className="font-12">Consumed Count</div>
                    <div className="font-12">{this.setConsumedCount(name)}</div>
                  </Col>
                  <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                    <span className="font-12">Max Transactions per Day</span>
                    <Slider
                      min={0}
                      max={Number(max_daily_transaction_volume) || 0}
                      step={5}
                      className="custom-slider"
                      value={this.setNewVolume(name)}
                      onChange={(value) => this.handleChangeTransactionVolume(name, value)}
                    />
                  </Col>
                  <Col xs={18} sm={18} md={18} lg={18} xl={18}>
                    <div className="show-slider-values margin-b-1">
                      <span>0</span>
                      <span>{max_daily_transaction_volume}</span>
                    </div>
                  </Col>
                </Row>
              </Col>
              {index !== limits.length - 1 ? <Divider className="margin-t-1 margin-b-1" /> : ''}
            </Fragment>
          ))}
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-left" >
            <Button onClick={() => history.goBack()} className="white-btn margin-r-2 width-4">Cancel</Button>
            <Button
              loading={isYblTransactionLimitsLoading}
              className="ant-btn green-btn width-4"
              onClick={this.handleSubmit}
            >
              Submit
            </Button>
          </Col>
        </StyledTransactionLimits>
      </Col>
    );
  }

  render() {
    const {
      cardData = {},
    } = this.props;
    const {
      modalType,
    } = this.state;
    return (
      <div>
        <Modal
          visible={!!modalType}
          onCancel={this.renderModalCloseFunction(modalType)}
          size="sm"
          classname="default-popup"
          title={null}
          maskClosable={false}
          footer={null}
        >
          {modalType && this.renderModalUI(modalType)}
        </Modal>
        <br clear="all" />
        <Container>
          <ZaggleCard>
            <Row align="middle" type="flex" gutter={24} className="margin-t-2">
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <h1>Manage Zaggle Cards</h1>
                <Breadcrumb separator="<" className="margin-b-2 font-12 custom-breadcrumb">
                  <Breadcrumb.Item href={constants.LINK_MY_PROFILE} className="crumb-link">My Account</Breadcrumb.Item>
                  <Breadcrumb.Item href={constants.LINK_PAY_BALANCE} className="crumb-link">Manage Cards</Breadcrumb.Item>
                  <Breadcrumb.Item>Manage Transaction Limits</Breadcrumb.Item>
                </Breadcrumb>
              </Col>
            </Row>
            <Card className="rounded noborder noshadow">
              <Row align="top" type="flex" gutter={30}>
                {this.renderCardImages(cardData)}
                {this.renderYesBankTransactionLimits()}
              </Row>
            </Card>
          </ZaggleCard>
        </Container>
      </div>
    );
  }
}

YesBankTransactionLimits.propTypes = YesBankTransactionLimitsProps;

const YesBankTransactionLimitsWrapper = Form.create({ name: 'normal_admin' })(YesBankTransactionLimits);
export default connect(yesBankTransactionLimitsMapStateToProps, yesBankTransactionLimitsMapDispatchToProps)(AppWrappperHOC(YesBankTransactionLimitsWrapper));
export { YesBankTransactionLimits, yesBankTransactionLimitsMapStateToProps, yesBankTransactionLimitsMapDispatchToProps, YesBankTransactionLimitsWrapper };



// WEBPACK FOOTER //
// client/containers/YesBankTransactionLimits/index.js